import React from 'react';
import { motion } from 'framer-motion';
import { infoSources, painPoints, selfQuestions } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Does this sound like you" className="bg-obsidian text-white" data-id="element-153" data-mp="2lp55ksdk54u7">
      <div className="mx-auto max-w-5xl px-5 py-16 lg:py-24" style={{
      paddingTop: "17px",
      paddingBottom: "20px"
    }} data-id="element-154" data-mp="26wbpp5udimp0">
        <div className="max-w-3xl" data-id="element-155" data-mp="2bv69aa060fa6">
          <h2 className="font-display text-4xl font-extrabold uppercase leading-none sm:text-6xl" data-id="element-156" data-mp="1xxhv1l0ls6e3">
            Does this sound like you?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-white/75" data-id="element-157" data-mp="21x8ltoq4qmim">
            You're training for a full-distance triathlon, but every time you try to organize your
            preparation, you end up overwhelmed by the amount of information.
          </p>
        </div>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-14" data-id="element-158" data-mp="3ie4d256bi2lc">
          <div data-id="element-159" data-mp="3nbmrgb33ta0q">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/45" data-id="element-160" data-mp="3nc5xatfhc7ye">You have</p>
            <ul className="mt-4 flex flex-wrap gap-2" data-id="element-161" data-mp="1yz3w4w4800fs">
              {infoSources.map(s => <li key={s} className="rounded-lg border border-white/15 px-3 py-1.5 text-sm text-white/80" data-id="element-162" data-mp="1u0iwoywslkse">
                  {s}
                </li>)}
            </ul>
            <p className="mt-5 text-lg font-semibold text-ember" data-id="element-163" data-mp="23rna3u6tkxl4">But they don't necessarily connect.</p>
          </div>
          <div data-id="element-164" data-mp="1g112g40q9fbn">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/45" data-id="element-165" data-mp="1g2uddvidilpg">You keep asking yourself</p>
            <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-166" data-mp="1b4ap3ogb4xtx">
              {selfQuestions.map(q => <li key={q} className="flex gap-2.5 text-[15px] leading-snug text-white/80" data-id="element-167" data-mp="1p428y5ti98fu">
                  <span className="font-bold text-ember" aria-hidden="true" data-id="element-168" data-mp="1k2mjm1kaofrn">?</span>
                  {q}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-14 border-y border-white/10 py-10 text-center" data-id="element-169" data-mp="2vjclx9llknfz">
          <p className="text-lg text-white/60" data-id="element-170" data-mp="1t55aq8oucxwh">This isn't necessarily a motivation problem.</p>
          <p className="mt-2 font-display text-5xl font-extrabold uppercase leading-none sm:text-7xl" data-id="element-171" data-mp="1y485n0b3xnqq">
            It's a <span className="text-electric" data-id="element-172" data-mp="2263662l7rx3g">system</span> problem.
          </p>
        </div>

        <ol className="divide-y divide-white/10" data-id="element-173" data-mp="274y0o1sjna3e">
          {painPoints.map(({
          icon: Icon,
          title,
          body,
          list,
          resolve
        }) => <motion.li key={title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid gap-4 py-9 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-12" data-id="element-174" data-mp="1afyr8jg8429m">
              <div className="flex items-start gap-4" data-id="element-175" data-mp="qqocp8s7rnd3">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-ember/30 bg-ember/10 text-ember" data-id="element-176" data-mp="qq5087lc1r6g">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-177" data-mp="o601l9fefy9u" />
                </span>
                <h3 className="pt-1 font-display text-2xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-178" data-mp="j75kcbx2yhru">
                  {title}
                </h3>
              </div>
              <div className="space-y-3 text-[15px] leading-relaxed text-white/70 lg:pt-1.5" data-id="element-179" data-mp="e6989b2krpbc">
                {body.map(b => <p key={b} data-id="element-180" data-mp="a8jwq2cr4ck7">{b}</p>)}
                {list && <ul className="space-y-1.5" data-id="element-181" data-mp="57npbet6y8a1">
                    {list.map(item => <li key={item} className="flex gap-2.5" data-id="element-182" data-mp="gntkcvt5w94">
                        <span className="text-ember" aria-hidden="true" data-id="element-183" data-mp="f324w4sitfh">—</span>
                        {item}
                      </li>)}
                  </ul>}
                {resolve && <p className="font-semibold text-white" data-id="element-184" data-mp="3moni1qj528ej">{resolve}</p>}
              </div>
            </motion.li>)}
        </ol>

        <div className="mt-8 rounded-2xl bg-electric px-6 py-9 text-center" data-id="element-185" data-mp="3ilr4wfcdb4hz">
          <p className="mx-auto max-w-2xl font-display text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-186" data-mp="3do8rabneo13n">
            If you answered yes, Sigma Smart™ has the solution.
          </p>
        </div>
      </div>
    </section>;
}